var Spinner = {
    template: "{{value}}",
    options: {
        max: 999,
        min: 1,
        spin: function( event, ui ) {
            var $this = $(this),
                min = $this.attr('min') ? $this.attr('min') : $this.data('uiSpinner').options.min,
                max = $this.attr('max') ? $this.attr('max') : $this.data('uiSpinner').options.max;

            if (ui.value > max) {
                $this.spinner( "value", max);

                return false;
            } else if (ui.value < min) {
                $this.spinner( "value", min);

                return false;
            }
        },
        stop: function(event) {
            $(event.target).trigger('change');
        }
    }
};

var Form = {};

Form.submit = function(selector) {
    $(selector).submit();
}

Form.ajaxPost = function(form, callback, datatype) {
    var $form = $(form);

    return $.post($form.attr('action'), $form.serialize(), callback, datatype);
}

Form.buildSpinners = function() {
    if (typeof jQuery.ui !== 'undefined' && typeof jQuery.ui.spinner !== 'undefined') {
        $.widget( "ui.spinner", $.ui.spinner, {
            _format: function(value) {
                var $elem = $(this.element),
                    append = '';

                if ($elem.data('spinner-append')) {
                    append = $elem.data('spinner-append');
                }

                return _.template(Spinner.template)({value: value});
            },
            _parse: function(value) {
                return parseInt(value);
            }
        });

        $(".ui-spinner").spinner(Spinner.options);
    }
}

Form.rebuildSpinners = function() {
    if (typeof jQuery.ui !== 'undefined' && typeof jQuery.ui.spinner !== 'undefined') {
        $(".ui-spinner").spinner().spinner("destroy");
        Form.buildSpinners();
    }
}

Form.datepicker = function() {
    if (typeof jQuery.ui !== 'undefined' && typeof jQuery.ui.datepicker !== 'undefined') {
        if (typeof jqueryUiI18nPath !== 'undefined') {
            $.getScript(jqueryUiI18nPath)
                .done(function( script, textStatus ) {
                    $.datepicker.setDefaults(Object.assign({}, $.datepicker.regional[document.documentElement.lang], {
                        dateFormat: 'dd.mm.yy',
                        showMonthAfterYear: false,
                        showButtonPanel: false,
                        yearSuffix: ''
                    }));
                })
                .fail(function(jqxhr, settings, exception) { });
        }

        $(".datepicker").datepicker();
    }
}

Form.fetchDependentOptions = function(elem, dependent, url, options) {
    var $elem = $(elem),
        $form = $elem.parents('form'),
        $dependent = $form.find('[name="' + dependent + '"]'),
        options = $.extend({
            template: '<option data-quantity="{{quantity}}" value={{id}}>{{name}}</option>',
            name : 'name',
            callback: null
        }, options);

    $.post(url, {id: $elem.val()}, function(response) {
        $dependent.find('option').remove();

        if (!response.data) {
            return;
        }

        for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].type == 'product') {
                $dependent.append(_.template(options.template)(response.data[i]));
            }
        }
        $dependent.trigger('change');

        if (options.callback) {
            options['callback']();
        }
    }, 'json');
};

$(function() {
    Form.buildSpinners();
    Form.datepicker();

    // Form input spinners
    $(".spinners .btn").bind("click", function() {
        var $this = $(this),
            $input = $this.parents(".input-group").children(".form-control"),
            value = parseInt($input.val()),
            update = parseInt($this.data("value")),
            new_value = value + update;
        $input.val(new_value).trigger("change");
        return false;
    });

    $("input").bind("change", function() {
        var $this = $(this),
            value = $this.val();

        if (value == '' && $this.data('allowempty')) {}
        else {
            if ($this.hasAttr('data-min') && value < parseInt($this.data('min'))) {
                $this.val($this.data('min'));
            }

            if ($this.hasAttr('data-max') && value > parseInt($this.data('max'))) {
              $this.val($this.data('max'));
            }
        }
    });

    $('form[data-formtype="registration"], form[data-formtype="order"], form[data-formtype="account"]')
        .find('[name="is_company"]').bind('change', function() {
            var $this = $(this),
                $form = $this.parents('form'),
                $group = $form.find('.company-group'),
                $inputs = $group.find('input[required], input[is-required], select[required], select[is-required]'),
                fieldsLength = $form[0].is_company.length,
                isCompany = false;

            rEvent.dispatch('Form.CompanyToggle.changed');

            if (fieldsLength > 1) {
                $this = $($form[0].is_company[fieldsLength - 1]);
            }

            $form[0].is_company.length - 1

            switch ($this.attr('type')) {
                case 'radio' :
                    isCompany = $form.find('input[name="is_company"]:checked').val() == 1;
                    break;
                case 'hidden' :
                    isCompany = $this.val() == 1;
                    break;
                default :
                    isCompany = $this.is(':checked');
                    break;
            }

            $inputs.attr('is-required', '1');
            if (isCompany) {
                $inputs.prop('required', true);
                $group.show();
            } else {
                $inputs.prop('required', false);
                $group.find('input').each(function() {
                    if ($(this).attr('type') == 'checkbox') {
                        $(this).prop('checked', false);
                    } else if ($(this).attr('type') != 'hidden') {
                        $(this).val('');
                    }
                });
                $group.hide();
            }
        }).trigger('change').end()
        .find('[name="shipping_same_as_billing"]').bind('change', function() {
            var $this = $(this),
                $form = $this.parents('form'),
                $group = $form.find('.shipping-group'),
                $inputs = $group.find('input[required], input[is-required], select[required], select[is-required]');

            $inputs.attr('is-required', '1');
            if ($this.is(':checked')) {
                $inputs.prop('required', false);
                $group.hide();
            } else {
                $inputs.prop('required', true);
                $group.show();
            }
        }).trigger('change').end();
});
